import Server from '../../core/components/server.js';
import State from './state.js';

class API {
	constructor(parent){
		this.server = new Server();
    this.state = State;
	}

  sendSurvey(data){
    const uri = '/survey/post';
    const params = {
      id: data.id,
      data: JSON.stringify(data.data),
    }
    this.server.post(uri, data);
  }

  getSuggestion(q){
  }   

  getResults(q, p, dev, src){
    var $this = this;
    const uri = src;
    const params = { 
        params: {
        q: q,
        p: p,
        dev: (dev) ? 1 : 0,
        }
    };
    return new Promise((resolve, reject) => {
      $this.server.get(uri, params, function(data){    
        window.__handlers = data.handlers;
        resolve(data);
      });
    });
  }   
}

window.__api = new API();

export default API;


// WEBPACK FOOTER //
// ./src/search/app/api.js